import React, {useMemo} from "react";
import "./introductionAssetDraft.css";

export function mapIntroductionDraftAssets(assets = []) {
    return assets.map((item, index) => ({
        ...item,
        id: index,
        name: item.assetName,
    }));
}

export function IntroductionAssetDraftList({
    assets = [],
    onRemove,
    readonly = false,
    emptyText = "도입자산을 추가해 주세요.",
    renderTrailing,
}) {
    const items = useMemo(() => mapIntroductionDraftAssets(assets), [assets]);

    if (items.length === 0) {
        return (
            <div className="introduction-asset-draft introduction-asset-draft--empty">
                <span className="introduction-asset-draft__empty-text">{emptyText}</span>
            </div>
        );
    }

    return (
        <div className="introduction-asset-draft">
            <ul className="introduction-asset-draft__list" role="list">
                {items.map((item) => (
                    <li key={`${item.id}-${item.assetName}`} className="introduction-asset-draft__item">
                        <span className="introduction-asset-draft__name" title={item.assetName}>
                            {item.assetName}
                        </span>
                        {item.groupName ? (
                            <span className="introduction-asset-draft__group" title={item.groupName}>
                                {item.groupName}
                            </span>
                        ) : null}
                        {renderTrailing ? (
                            <span className="introduction-asset-draft__trailing">{renderTrailing(item)}</span>
                        ) : null}
                        {!readonly && onRemove ? (
                            <button
                                type="button"
                                className="introduction-asset-draft__remove"
                                aria-label={`${item.assetName} 제거`}
                                onClick={() => onRemove(item.id)}
                            >
                                ×
                            </button>
                        ) : null}
                    </li>
                ))}
            </ul>
        </div>
    );
}
